/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { UserStateOfUse } from './UserStateOfUse';
import {
    UserStateOfUseFromJSON,
    UserStateOfUseFromJSONTyped,
    UserStateOfUseToJSON,
} from './UserStateOfUse';
import type { UserAccountType } from './UserAccountType';
import {
    UserAccountTypeFromJSON,
    UserAccountTypeFromJSONTyped,
    UserAccountTypeToJSON,
} from './UserAccountType';

/**
 * 
 * @export
 * @interface CreateUpdateUserDto
 */
export interface CreateUpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    profilePictureId?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUpdateUserDto
     */
    assignedRoles?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    description?: string | null;
    /**
     * 
     * @type {UserAccountType}
     * @memberof CreateUpdateUserDto
     */
    accountType?: UserAccountType;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    mobileNumber?: string | null;
    /**
     * 
     * @type {UserStateOfUse}
     * @memberof CreateUpdateUserDto
     */
    state?: UserStateOfUse;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateUserDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUpdateUserDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateUserDto
     */
    $type?: CreateUpdateUserDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUpdateUserDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoCreateUpdateUserDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.CreateUpdateUserDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUpdateUserDtoTypeEnum = typeof CreateUpdateUserDtoTypeEnum[keyof typeof CreateUpdateUserDtoTypeEnum];



/**
 * Check if a given object implements the CreateUpdateUserDto interface.
 */
export function instanceOfCreateUpdateUserDto(value?: unknown): value is CreateUpdateUserDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUpdateUserDtoTypeEnum)[0];
}

export function CreateUpdateUserDtoFromJSON(json: any): CreateUpdateUserDto {
    return CreateUpdateUserDtoFromJSONTyped(json, false);
}

export function CreateUpdateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'emailAddress': json['emailAddress'],
        'profilePictureId': json['profilePictureId'] == null ? undefined : json['profilePictureId'],
        'assignedRoles': json['assignedRoles'] == null ? undefined : json['assignedRoles'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'accountType': json['accountType'] == null ? undefined : UserAccountTypeFromJSON(json['accountType']),
        'mobileNumber': json['mobileNumber'] == null ? undefined : json['mobileNumber'],
        'state': json['state'] == null ? undefined : UserStateOfUseFromJSON(json['state']),
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateUpdateUserDtoToJSON(value?: CreateUpdateUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'emailAddress': value['emailAddress'],
        'profilePictureId': value['profilePictureId'],
        'assignedRoles': value['assignedRoles'],
        'title': value['title'],
        'description': value['description'],
        'accountType': UserAccountTypeToJSON(value['accountType']),
        'mobileNumber': value['mobileNumber'],
        'state': UserStateOfUseToJSON(value['state']),
        'lastModificationTime': value['lastModificationTime'],
        'isAvailable': value['isAvailable'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'iuid': value['iuid'],
        '$type': value['$type'],
    });
}

